// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".commands_title[data-v-4d95562b]{padding-bottom:10px;color:var(--el-color-primary);font-weight:bolder;font-size:15px}", ""]);
// Exports
module.exports = exports;
